var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unicom-progress",class:_vm.percentage === 0 ? 'boder-0': ''},[_c('van-progress',{attrs:{"percentage":_vm.percentage,"pivot-color":"#587DF1","color":"#587DF1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }